import type { LucideIcon } from "lucide-react";
import { cn } from "@eduviaos/ui-kit";
import { SectionCard } from "../Section";

export interface CompactActionItem {
  id: string;
  label: string;
  icon: LucideIcon;
  tint: "violet" | "orange" | "green" | "blue";
  onClick: () => void;
}

const TINTS: Record<CompactActionItem["tint"], string> = {
  violet: "bg-primary/12 text-primary",
  orange: "bg-orange-500/12 text-orange-600 dark:text-orange-400",
  green: "bg-emerald-500/12 text-emerald-600 dark:text-emerald-400",
  blue: "bg-sky-500/12 text-sky-600 dark:text-sky-400",
};

/** Home-tab quick actions — icon + label tiles in a responsive row. */
export function QuickActionCompact({ items }: { items: CompactActionItem[] }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <button
            key={item.id}
            type="button"
            onClick={item.onClick}
            className="group text-left transition-transform duration-150 ease-out active:scale-[0.98] motion-reduce:transition-none"
          >
            <SectionCard className="group-hover:bg-muted/30 flex h-full flex-col items-center gap-2.5 p-3.5 text-center transition-colors duration-150 sm:p-4">
              <span className={cn("grid size-11 place-items-center rounded-xl", TINTS[item.tint])}>
                <Icon className="size-5" aria-hidden="true" />
              </span>
              <p className="text-xs font-semibold leading-tight">{item.label}</p>
            </SectionCard>
          </button>
        );
      })}
    </div>
  );
}
